module.exports = __webpack_public_path__ + "img/simulation.7aad2fb1.png";